const styles = (theme) => ({
    header: {
        alignItems: 'center',
        marginTop: '20px',
        marginBottom: '20px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    title: {
        padding: '0 12px !important',
        '& h1': {
            fontSize: '18px',
            fontWeight: '400',
            margin: '0',
        },
    },
    btnBack: {
        textTransform: 'none',
        fontSize: '18px',
        fontWeight: '400',
        lineHeight: '1',
        color: '#aaa',
    },
    linksBreadcrumb: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        listStyle: 'none',
        margin: '0',
        padding: '0',
        '& li': {
            borderRight: '1px solid lightgray',
        },
        '& li:first-child button': {
            textTransform: 'lowercase',
            fontSize: '14px',
            color: theme.palette.primary.main,
        },
        '& li:last-child': {
            border: 'none',
            color: 'rgba(0, 0, 0, 0.87)',
        },
    },
    rightInfo: {
        textAlign: 'right',
    },
});

export default styles;
